import { Route } from '@angular/router';
import { authGuard, kycGuard, TokenGuard } from '@itb-monorepo/services';
import { NotFoundComponent } from '@itb-monorepo/shared-ui/feedback';

export const appRoutes: Route[] = [
  { path: 'not-found', component: NotFoundComponent },
  {
    path: 'l',
    canActivate: [TokenGuard],
    loadComponent: () =>
      import('@itb-monorepo/auth').then((m) => m.AuthComponent),
    children: [
      {
        path: '',
        loadComponent: () =>
          import('@itb-monorepo/auth').then((m) => m.SignUpComponent),
        title: '',
      },
    ],
  },
  {
    path: 'auth',
    canActivate: [TokenGuard],
    loadComponent: () =>
      import('@itb-monorepo/auth').then((m) => m.AuthComponent),
    children: [
      {
        path: 'sign-up',
        loadComponent: () =>
          import('@itb-monorepo/auth').then((m) => m.SignUpComponent),
        title: 'AUTH.SignUp',
      },
      {
        path: 'sign-in',
        loadComponent: () =>
          import('@itb-monorepo/auth').then((m) => m.SignInComponent),
        title: 'AUTH.SignIn',
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('@itb-monorepo/auth').then((m) => m.ResetPasswordComponent),
        title: 'AUTH.ResetYourPassword',
      },
    ],
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@itb-monorepo/layout').then((m) => m.DashboardLayoutComponent),
    data: { subsSystem: 'trader' },
    children: [
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./components/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
        title: 'Dashboard',
        data: {
          hasTour: true,
          tourType: 'dashboard',
        },
      },
      {
        path: 'special-bonuses',
        loadComponent: () =>
          import('@itb-monorepo/bonuses').then((m) => m.BonusesComponent),
        title: 'Bonus',
      },
      {
        path: 'verification',
        loadComponent: () =>
          import('@itb-monorepo/verification').then(
            (m) => m.VerificationComponent
          ),
        children: [
          {
            canActivate: [kycGuard],
            path: 'phone',
            loadComponent: () =>
              import('@itb-monorepo/verification').then(
                (m) => m.MobileVerificationComponent
              ),
            title: 'VERIFICATION.Mobile',
            data: { section: 'kyc' },
          },
          {
            canActivate: [kycGuard],
            path: 'personal-information',
            loadComponent: () =>
              import('@itb-monorepo/verification').then(
                (m) => m.PersonalInformationVerificationComponent
              ),
            title: 'VERIFICATION.PersonalDetails',
            data: { section: 'kyc' },
          },
          {
            canActivate: [kycGuard],
            path: 'bank-card',
            loadComponent: () =>
              import('@itb-monorepo/verification').then(
                (m) => m.BankCardVerificationComponent
              ),
            title: 'BankCard',
            data: { section: 'kyc' },
          },
          {
            path: '',
            redirectTo: 'phone',
            pathMatch: 'full',
          },
        ],
      },
      {
        path: 'accounts',
        loadComponent: () =>
          import('./components/accounts/accounts.component').then(
            (m) => m.AccountsComponent
          ),
        children: [
          {
            path: 'create/:platform/:type',
            loadComponent: () =>
              import('@itb-monorepo/app-components').then(
                (m) => m.CreateAccountComponent
              ),
            title: 'ACCOUNTS.CreatAccount',
          },
          {
            path: 'details/:platform/:accountId',
            loadComponent: () =>
              import(
                './components/accounts/account-details/account-details.component'
              ).then((m) => m.AccountDetailsComponent),
            title: 'AccountDetails',
          },
          {
            path: 'edit/:platform/:accountId',
            loadComponent: () =>
              import('@itb-monorepo/app-components').then(
                (m) => m.EditAccountComponent
              ),
            title: 'EditAccount',
          },
          {
            path: 'list/:platform/:kind',
            loadComponent: () =>
              import(
                './components/accounts/accounts-list/accounts-list.component'
              ).then((m) => m.AccountsListComponent),
            title: 'SIDEBAR.MyAccounts',
          },
        ],
      },
      {
        path: 'statistics',
        loadComponent: () =>
          import('@itb-monorepo/statistics').then((m) => m.StatisticsComponent),
        children: [
          {
            path: 'trades',
            loadComponent: () =>
              import('@itb-monorepo/statistics').then((m) => m.TradesComponent),
            title: 'DASHBOARD.TradingStatistics',
          },
          {
            path: 'assets',
            loadComponent: () =>
              import('@itb-monorepo/statistics').then((m) => m.AssetsComponent),
            title: 'SIDEBAR.AssetStatistics',
          },
        ],
      },
      {
        path: 'ticket',
        loadComponent: () =>
          import('@itb-monorepo/ticket').then((m) => m.TicketComponent),
        children: [
          {
            path: 'create',
            loadComponent: () =>
              import('@itb-monorepo/ticket').then(
                (m) => m.CreateTicketComponent
              ),
            title: 'TICKET.CreateTicket',
          },
          {
            path: 'list',
            loadComponent: () =>
              import('@itb-monorepo/ticket').then(
                (m) => m.TicketsListComponent
              ),
            title: 'TICKET.MyTickets',
          },
          {
            path: 'call-request',
            loadComponent: () =>
              import('@itb-monorepo/ticket').then(
                (m) => m.CallRequestComponent
              ),
            title: 'TICKET.CallRequest',
          },
        ],
      },
      {
        path: 'contests',
        loadComponent: () =>
          import('@itb-monorepo/contests').then((m) => m.ContestsComponent),
        children: [
          {
            path: 'list',
            loadComponent: () =>
              import('@itb-monorepo/contests').then(
                (m) => m.MyCompetitionsComponent
              ),
            title: 'CONTESTS.MyCompetitions',
          },
          {
            path: 'upcoming',
            loadComponent: () =>
              import('@itb-monorepo/contests').then(
                (m) => m.UpcomingContestsComponent
              ),
            title: 'CONTESTS.UpcomingContests',
          },
        ],
      },
      {
        path: 'financial',
        loadComponent: () =>
          import('@itb-monorepo/financial').then((m) => m.FinancialComponent),
        children: [
          {
            path: 'deposit',
            loadComponent: () =>
              import('@itb-monorepo/financial').then((m) => m.DepositComponent),
            title: 'ACCOUNTS.DepositMoney',
          },
          {
            path: 'withdraw',
            loadComponent: () =>
              import('@itb-monorepo/financial').then(
                (m) => m.WithdrawComponent
              ),
            title: 'ACCOUNTS.CashWithdrawal',
          },
          {
            path: 'transfer',
            loadComponent: () =>
              import('@itb-monorepo/financial').then(
                (m) => m.TransferComponent
              ),
            title: 'TransferMoney',
          },
          {
            path: 'reports/:status',
            loadComponent: () =>
              import('@itb-monorepo/financial').then(
                (m) => m.FinancialReportsComponent
              ),
            title: 'FinancialReports',
          },
        ],
      },
      {
        path: 'setting',
        loadComponent: () =>
          import('@itb-monorepo/setting').then((m) => m.SettingComponent),
        children: [
          {
            canActivate: [kycGuard],
            path: 'profile',
            loadComponent: () =>
              import('@itb-monorepo/setting').then((m) => m.ProfileComponent),
            title: 'Profile',
            data: { section: 'settings' },
          },
          {
            canActivate: [kycGuard],
            path: 'bank-card',
            loadComponent: () =>
              import('@itb-monorepo/setting').then((m) => m.BankCardComponent),
            title: 'BankCard',
            data: { section: 'settings' },
          },
          {
            path: 'security',
            loadComponent: () =>
              import('@itb-monorepo/setting').then((m) => m.SecurityComponent),
            title: 'ChangePassword',
          },
        ],
      },
      {
        path: 'services',
        loadComponent: () =>
          import('@itb-monorepo/company-services').then(
            (m) => m.CompanyServicesComponent
          ),
        children: [
          {
            path: 'download-platforms',
            loadComponent: () =>
              import('@itb-monorepo/company-services').then(
                (m) => m.DownloadPlatformsComponent
              ),
            title: 'DownloadMT5',
          },
          {
            path: 'instruments',
            loadComponent: () =>
              import('@itb-monorepo/company-services').then(
                (m) => m.InstrumentsComponent
              ),
            title: 'Instruments',
            data: { external: false },
          },
          {
            path: 'instruments/:symbol',
            loadComponent: () =>
              import('@itb-monorepo/company-services').then(
                (m) => m.SingleInstrumentComponent
              ),
            title: 'Instrument',
            data: { external: false },
          },
        ],
      },
      {
        path: 'web-trade/:platform',
        loadComponent: () =>
          import('@itb-monorepo/app-components').then(
            (m) => m.WebTradeComponent
          ),
        title: 'SIDEBAR.WebTrade',
      },
      {
        path: 'invite-friends',
        loadComponent: () =>
          import('./components/invite-friends/invite-friends.component').then(
            (c) => c.InviteFriendsComponent
          ),
        title: 'SIDEBAR.Referral',
      },
      {
        path: 'forex-calculator',
        loadComponent: () =>
          import('@itb-monorepo/forex-calculator').then(
            (c) => c.ForexCalculatorComponent
          ),
        data: { external: false },
        children: [
          {
            path: 'currency-converter',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.CurrencyConverterComponent
              ),
            title: 'CalculatorForex',
          },
          {
            path: 'position-size',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.PositionSizeComponent
              ),
            title: 'Position size calculator',
          },
          {
            path: 'pip',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.PipComponent
              ),
            title: 'Pip value calculator',
          },
          {
            path: 'margin',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.MarginComponent
              ),
            title: 'Margin calculator',
          },
          {
            path: 'fibonacci',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.FibonacciComponent
              ),
            title: 'Fibonacci calculator',
          },
          {
            path: 'pivot-point',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.PivotPointComponent
              ),
            title: 'Pivot point calculator',
          },
          {
            path: 'profit',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.ProfitCalculatorComponent
              ),
            title: 'Profit calculator',
          },
          {
            path: 'swap',
            loadComponent: () =>
              import('@itb-monorepo/forex-calculator').then(
                (m) => m.SwapCalculatorComponent
              ),
            title: 'swap calculator',
          },
        ],
      },
      {
        path: 'forex-calendar',
        loadComponent: () =>
          import('@itb-monorepo/forex-calendar').then(
            (c) => c.ForexCalendarComponent
          ),
        data: { external: false },
        title: 'SIDEBAR.ForexCalendar',
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: ':lang/gold',
    loadComponent: () =>
      import('@itb-monorepo/company-services').then(
        (m) => m.GoldSymbolComponent
      ),
    data: { external: false },
  },
  { path: '**', redirectTo: '/not-found' },
];
